export default __webpack_public_path__ + "static/media/crossPrimary.82993393.svg";